const ClientForgotUserIDMapper = (clientForgotUserID) => {
    if (clientForgotUserID && clientForgotUserID.data.msg)
        return { success: true, message: clientForgotUserID.data.msg };
    return { message: "", success: false };
};
export default ClientForgotUserIDMapper;
